/**
 * Defines the events associated with the Button component.
 */
export const ToastEvents = {
  ACTION_CLICK: 'luds-button:link-click',
} as const;

/**
 * Defines the possible icons for the Toast component.
 */
export const toastIconMap = new Map<string, string>([
  ['success', 'completed'],
  ['error', 'alert'],
]);

/**
 * Defines the variants of Toast component.
 */
export const ToastVariants = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export type ToastVariant = (typeof ToastVariants)[keyof typeof ToastVariants];
